import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import clsx from 'clsx';
import { ComponentProps } from 'react';
import { FieldPath, FieldValues, UseFormReturn } from 'react-hook-form';

interface FormInputFileProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> {
  form: UseFormReturn<TFieldValues>;
  name: TName;
  label: string;
  className?: string;
  inputProps?: ComponentProps<typeof Input> & { 'data-testid'?: string };
}

export function FormInputFile<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ form, name, label, inputProps = {}, className = '' }: FormInputFileProps<TFieldValues, TName>) {
  const { className: inputClassName, required, onChange: inputOnChange, ...others } = inputProps;

  return (
    <FormField
      control={form.control}
      name={name}
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      render={({ field: { onChange, value, ...fieldProps } }) => (
        <FormItem className={className}>
          <FormLabel className="font-bold">
            {label}
            {required && '*'}
          </FormLabel>
          <FormControl>
            <Input
              {...fieldProps}
              {...others}
              className={clsx('w-2/3', inputClassName)}
              onChange={(event) => {
                onChange(event.target.files);
                inputOnChange?.(event);
              }}
              type="file"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
